const translations = {
    acres: 'acres',
    activity: 'Activity',
    editApplication: 'Edit Application',
    gallons: 'gallons',
    linkedEntities: 'Linked Entities'
};

export default translations;
